const BANNER_ITEM_COLORS = {
    success: "#009892",
    alert: "#b57820",
};

export { BANNER_ITEM_COLORS };
//# sourceMappingURL=constans.js.map
